import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image19 from "../../../../assets/images/Blog42/image19 momentum unwind.png";
import image7 from "../../../../assets/images/Blog42/image7 show me the money AI.png";
import image39 from "../../../../assets/images/Blog42/image39 Q3 earnings BOOM (1).png";
import image41 from "../../../../assets/images/Blog42/image41 fy25 up FY26 slowing (1).png";
import image10 from "../../../../assets/images/Blog42/image10 no tariff free lunch (1).png";
import image46 from "../../../../assets/images/Blog42/image46 fed injections.png";
import image36 from "../../../../assets/images/Blog42/image36 Bailey bottles the cut.png";
import image53 from "../../../../assets/images/Blog42/image53 a grand supercycle meltup ahead_.png";
import image45 from "../../../../assets/images/Blog42/image45 VIX implosion bottomed us out.png";
import image55 from "../../../../assets/images/Blog42/image55 taking a breath.png";
import image26 from "../../../../assets/images/Blog42/image26 AI virtuous circle flywheel.png";
import image25 from "../../../../assets/images/Blog42/image25 GOOGLE going vertical.png";
import image57 from "../../../../assets/images/Blog42/image57 gold hugging (1).png";
import image60 from "../../../../assets/images/Blog42/image60 oil a bit slippy (1).png";
import image31 from "../../../../assets/images/Blog42/image31 crypto nearly down on the year.png";
import image64 from "../../../../assets/images/Blog42/image64 ETH layer-2 hack.png";
import image72 from "../../../../assets/images/Blog42/image72 institutional HOLD UP (1).png";
import image49 from "../../../../assets/images/Blog42/image49 small ripples not bubbles.png";
import image69 from "../../../../assets/images/Blog42/image69 we've seen this movie before.png";
const Blog42 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – November 10th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Rotation, Policy Fog, and a Market That Refuses to Break</p>
        <p>
          Despite a week filled with warnings — AI exuberance, political uncertainty, credit-market whispers, and a government data blackout — the market delivered something few expected:{" "}
          <span className="highlightedText">resilience beneath the surface.</span> What looked like risk-off was, in reality, a sharp sector rotation hiding inside the noise.
        </p>
        <p>
          The tape was messy, but not broken.<br></br>
          The narrative was loud, but price action was quietly orderly.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: A Reset, Not a Breakdown</p>
              <p>
                The week began with bearish chatter: talk of an overdue crash, hand-wringing about AI excess, and even an odd cameo from Michael Burry trying to stir support for his short on Palantir.
                But markets didn’t crack — they <span className="highlightedText">rotated.</span>
              </p>
              <p>Equal-weight S&P outperformed until Friday, when a powerful post-lunch rally reversed the tape despite disappointing UoM sentiment numbers.</p>
              <p>Gold defended its 50-day. Oil drifted but stayed constructive. Crypto tested lows but bounced hard as long-term holders handed supply to institutional “Treasury Whales.</p>
              <p>Despite the gloom, liquidity kept flowing — and that mattered more than the noise.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=" momentum unwind"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="show me the money"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Corporate earnings remained exceptionally strong, beating Q1 and Q2 — but analysts still refuse to lift FY26 expectations.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image39}
                    alt="Q3 earnings BOOM"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="fy25 up FY26 slowing"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The short-term looks great.<br></br>
                The long-term still looks foggy.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Tariffs, Fed Caution, Shutdown Chaos</p>

              <p className="highlightedText">1. SCOTUS vs Trump’s Tariffs: A Potential $80B Shock</p>

              <p>Supreme Court arguments challenged the legality of Trump’s reciprocal tariffs, with Chief Justice Roberts calling them effectively “taxes on Americans.”</p>
              <p>
                If they are struck down, the Treasury could owe <span className="highlightedText">$80 billion in refunds,</span> steepening the curve and complicating deficit math.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="no tariff free"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">2. Fed Tone: Cautious, Split, and Inflation-Focused</p>

              <p>Fed speakers delivered a mixed bag:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Jefferson: policy still restrictive</p>
                </li>
                <li className="themesPointer">
                  <p>Powell: December cut is “far from a foregone conclusion”</p>
                </li>
                <li className="themesPointer">
                  <p>Waller and Goolsbee diverged</p>
                </li>
                <li className="themesPointer">
                  <p>Hammack was aggressively hawkish</p>
                </li>
              </ul>
              <p>Meanwhile, QT runoff ended, and markets absorbed the prior 25bps cut cleanly.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image46}
                    alt="fed injections"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image46)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The Fed doesn’t want to talk about stocks — but they certainly don’t mind cooling them.</p>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">3. BOE’s Missed Opportunity</p>

              <p>The BOE nearly surprised with a cut, but Bailey refused to back the doves, opting for caution despite clear economic strain in the U.K.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image36}
                    alt=" Bailey bottles"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image36)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Shutdown disruptions added another layer of confusion — with most economic releases frozen, traders relied entirely on private data like ADP, Challenger, and Redbook.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Rotation Beneath the Surface</p>
              <p className="highlightedText">1. S&P 500 Defends 50DMA, Reverses Hard Into Friday</p>
              <p>
                The S&P 500 tested its 50dma near <span className="highlightedText">6666</span> (ominous, but powerful) and launched a fierce reversal.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image53}
                    alt="grand supercycle meltup"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image53)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt="implosion bottomed"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Breadth broadened.
                <br></br> Small and midcaps led.<br></br>
                Equal-weight S&P outperformed cap-weighted.
              </p>
              <p>A correction in sentiment, not fundamentals.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image55}
                    alt="taking a breath"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image55)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">2. Tech: Gravity, Not Failure</p>
              <p>Mega-cap tech finally cooled:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Semis: –4% to –6%</p>
                </li>
                <li className="themesPointer">
                  <p>FANG+: pulled back</p>
                </li>
                <li className="themesPointer">
                  <p>XLK retook its opening levels</p>
                </li>
                <li className="themesPointer">
                  <p>AI leaders are still attracting massive capex</p>
                </li>
              </ul>
              <p>But the story was position-reset, not structural damage.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt="AI virtuous circle flywheel"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt="GOOGLE going vertical"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>NVIDIA’s dominance remains a structural force — its $5T market cap warps everything around it.</p>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">3. Energy, Staples, Health Care Rotate In</p>
              <p>
                Energy caught a bid from surging natural gas prices. <br></br>
                Health care and staples were steady winners.
                <br></br>
                Utilities and real estate stabilised late as yields softened.
              </p>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">4. Gold & Oil</p>
              <p>Gold hugged $4k and its 20dma.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image57}
                    alt="gold hugging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image57)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Oil drifted and struggled with long-term resistance.</p>
              <div className="relatedImg">
                <img
                  src={image60}
                  alt="Oil drifted and struggled with long-term resistance."
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image60)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="contentDiv listOfRecap">
              <p className="highlightedText">5. Crypto: The Liquidity Tell</p>
              <p>
                Bitcoin repeatedly broke $100k, then staged a clean reversal.<br></br> Ethereum held its 200dma despite the Layer-2 hack.<br></br> Solana saw strong inflows.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt="gold hugging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image64}
                    alt="gold hugging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image64)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Crypto once again signalled risk sentiment hours before equities followed.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Layoffs, Rotation Flows, and Cross-Asset Stabilisation</p>
              <p>
                Markets kicked off cautiously but rallied into Friday as private-sector data filled the shutdown vacuum, layoffs spiked, and rotations replaced fear. Sentiment improved as breadth
                broadened late week, crypto stabilised, and earnings once again outperformed short-term expectations even as long-term visibility softened.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>The government shutdown halted key releases, forcing traders to rely on ADP, Challenger, Redbook, and UoM. Challenger job cuts surged to{" "}
                    <span className="highlightedText">153,074,</span> the highest October print since 2003, pushing YTD layoffs above <span className="highlightedText">1 million.</span> UoM
                    personal-finance sentiment collapsed, inflation expectations stayed elevated, and Fed speakers kept December rate-cut odds uncertain with mixed hawkish-dovish tones.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span>
                    <br></br>China posted a rare CPI uptick after months of deflation, though the move appears Golden-Week-driven rather than structural. The improvement eased global disinflation
                    pressure temporarily, but a sustained rise would remove one of the market’s biggest macro tailwinds.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>
                    <br></br>Q3 earnings beat both Q1 and Q2 momentum, even as
                    <span className="highlightedText"> FY26 estimates drifted lower again. </span>M&A surged across sectors — from Kimberly-Clark’s ~$50B Kenvue deal to Pfizer and Novo Nordisk bidding
                    for Metsera — reinforcing corporate balance-sheet strength in an otherwise cloudy macro environment.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image39}
                      alt=" Q3 earnings BOOM"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image39)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image41}
                      alt="fy25 up FY26 slowing"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image41)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </ul>

              <p className="highlightedText">Commodities:</p>
              <p>
                Gold held the <span className="highlightedText">$4k</span> area and its 20DMA, remaining structurally constructive. Oil drifted lower and struggled to reclaim long-term resistance amid
                seasonally soft demand and macro uncertainty.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image60}
                    alt="oil a bit slippy"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image60)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Crypto:</p>
              <p>
                No clean breakout, but no breakdown either. Bitcoin slipped below <span className="highlightedText">$100k</span> multiple times before reclaiming it, while Ethereum held its 200DMA
                despite a $100M Layer-2 hack. Large wallets accumulated steadily as long-term holders handed supply to institutional treasuries.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image72}
                    alt=" institutional HOLD UP"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image72)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The week reinforced a rotation-driven, liquidity-sensitive market: cautious at the surface, but quietly stabilising underneath.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Shutdown Filters, Fed Firehose, and Rotation Catalysts</p>
              <p>
                Four days of dense global data, an intense Fed-speaker lineup, and AI-sensitive earnings shape the week ahead. With U.S. government releases still constrained, traders will lean on
                private-sector indicators to gauge labour conditions and inflation stickiness.
              </p>
              <p className="highlightedText">Monday, Nov 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Australia: Building Approvals</p>
                </li>
                <li className="themesPointer">
                  <p>Japan: Coincident Index, Leading Index</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: Sentix Investor Confidence</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Wholesale Inventories, Wholesale Trade Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Talking Heads: BoJ Nakagawa; BoE Lombardelli; FOMC Daly; Fed Musalem</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Nov 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Canada: Holiday (Armistice/Remembrance)</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: Earnings & Unemployment</p>
                </li>
                <li className="themesPointer">
                  <p>China: M2, New Loans, Total Social Financing</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: German & Eurozone ZEW</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: NFIB Small Business Survey, Redbook</p>
                </li>
                <li className="themesPointer">
                  <p>Talking Heads: Lagarde; Vujcic; Sleijpen; Greene; Dhingra; Jones</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Nov 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Germany: CPI</p>
                </li>
                <li className="themesPointer">
                  <p>Italy: Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>Global: OPEC Monthly Report</p>
                </li>{" "}
                <li className="themesPointer">
                  <p>U.S.: MBA Mortgage Data; API Crude Oil</p>
                </li>
                <li className="themesPointer">
                  <p>Auctions: German 30-Year Bund; U.S. 10-Year Note</p>
                </li>
                <li className="themesPointer">
                  <p>Talking Heads: Barr; Schnabel; De Guindos; Pill; Williams; Paulson; Waller; Bostic; Miran; Logan</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Nov 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Australia: Unemployment</p>
                </li>
                <li className="themesPointer">
                  <p>U.K.: GDP, Industrial Production, Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Jobless Claims; Core CPI; Productivity; Oil Inventories</p>
                </li>
                <li className="themesPointer">
                  <p>Earnings: Disney; Applied Materials</p>
                </li>
                <li className="themesPointer">
                  <p>Talking Heads: Kocher; Schnabel; Bailey; Nagel; Hammack; Tschudin; McPhee</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Nov 14</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>China: Retail Sales; Industrial Production; Unemployment</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: CPI; GDP; Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>Canada: Manufacturing & Wholesale Sales</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Atlanta Fed GDPNow</p>
                </li>
                <li className="themesPointer">
                  <p>Earnings: JD.com; Nubank</p>
                </li>
                <li className="themesPointer">
                  <p>Talking Heads: Vujcic; Balz; Elderson; Bostic; Logan</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image49}
                    alt="small ripples not bubbles"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image49)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Bounce Valid But Fragile and Flow-Dependent</p>
              <p>
                The market’s rebound remains intact. Liquidity pockets are improving, earnings are doing the heavy lifting, and rotation continues to broaden participation. But narrow leadership,
                elevated correlations, and macro fog demand precision and discipline.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Rotation improved, but leadership remains concentrated. Buy controlled dips in structurally strong areas; avoid weak sectors fighting major trend breaks. Breadth needs to
                    be confirmed for momentum to extend.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Oil:</span> <br></br>Gold’s resilience above <span className="highlightedText">$4k</span> keeps the structural bull case alive. Oil remains
                    vulnerable with soft demand and resistance overhead — conviction requires a clean reclaim of trend levels.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Positioning reset is mostly complete. Institutional flows continue, and BTC’s Friday reversal again led equities. A
                    stable liquidity backdrop could trigger range breakouts later this month.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Shutdown-distorted data makes Fed commentary unusually important. December rate-cut odds are drifting, not fixed. If
                    funding stress eases into December’s QT shift, risk assets can extend higher; if not, volatility returns quickly.
                  </p>
                </li>
              </ul>
              <p>
                The market remains bullish — but narrow, levered, and sensitive to liquidity tremors. Trade strength tactically, buy weakness selectively, and stay alert to rotation inflexion points.
              </p>
              <p>The message is simple:</p>
              <p className="highlightedText">Trade the setups, not the stories. Be tactical. Respect rotation. Survive the week.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image69}
                    alt="we’ve seen this movie before"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image69)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image57}
                    alt="gold hugging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image57)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image72}
                    alt=" institutional HOLD UP"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image72)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1w-lh2mdQ9aWn6VQ02rfttzWpmMkAZ0ikv1su7grT9Fo/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog42;
